"use strict";
module.exports = function(it) {
  return it === null || it === void 0;
};
